















import {Vue, Component, Prop} from "vue-property-decorator";

@Component({})
	export default class ModalWindow extends Vue{

    @Prop()
	visible: boolean;

    @Prop()
	image: string;

    closeDialog(){
        this.$emit("close");
	}

    prevSlide(){
        this.$emit("prevSlide");
	}

	nextSlide(){
        this.$emit("nextSlide");
	}

}
